import PortfolioCarousel from "./PortfolioCarousel";
import type { ReturnsSet, Strategy } from "@repo/api";
import { useTranslation } from "@repo/core";
import LoadingConstituents from "./LoadingConstituents";
import MissingConstituents from "./MissingConstituents";

interface PortfolioConstituentsProps {
  strategy?: Strategy;
  portfolio: ReturnsSet | null;
  isLoading?: boolean;
  className?: string;
  onDateChange?: (date: string) => void;
}

/**
 * Portfolio constituents component showing current and historic portfolio data
 */
export const PortfolioConstituents = ({
  strategy,
  portfolio,
  isLoading = false,
  className = "",
  onDateChange,
}: PortfolioConstituentsProps) => {
  const { tPortfolio } = useTranslation();
  if (isLoading) {
    return <LoadingConstituents className={className} />;
  }

  if (!portfolio) {
    return <MissingConstituents className={className} />;
  }

  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}
      data-tour="portfolio-constituents"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {tPortfolio("constituentsTitle")}
        </h2>
      </div>

      {/* Horizontal divider */}
      <hr className="border-gray-200 mb-6" />

      {/* Portfolio Carousel */}
      <PortfolioCarousel
        strategy={strategy}
        portfolio={portfolio}
        className="w-full"
        onDateChange={onDateChange}
      />
    </div>
  );
};

export default PortfolioConstituents;
